
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation resources
import commonEN from './locales/en/common.json';
import commonFR from './locales/fr/common.json';
import dashboardEN from './locales/en/dashboard.json';
import dashboardFR from './locales/fr/dashboard.json';
import classesEN from './locales/en/classes.json';
import classesFR from './locales/fr/classes.json';
import clientsEN from './locales/en/clients.json';
import clientsFR from './locales/fr/clients.json';
import indexEN from './locales/en/index.json';
import indexFR from './locales/fr/index.json';
import authEN from './locales/en/auth.json';
import authFR from './locales/fr/auth.json';
import scheduleEN from './locales/en/schedule.json';
import scheduleFR from './locales/fr/schedule.json';
import settingsEN from './locales/en/settings.json';
import settingsFR from './locales/fr/settings.json';
import coachesEN from './locales/en/coaches.json';
import coachesFR from './locales/fr/coaches.json';
import coursesEN from './locales/en/courses.json';
import coursesFR from './locales/fr/courses.json';
import subscriptionsEN from './locales/en/subscriptions.json';
import subscriptionsFR from './locales/fr/subscriptions.json';
import athleteEN from './locales/en/athlete.json';
import athleteFR from './locales/fr/athlete.json';
import inventoryEN from './locales/en/inventory.json';
import inventoryFR from './locales/fr/inventory.json';
import paymentsEN from './locales/en/payments.json';
import paymentsFR from './locales/fr/payments.json';
import coachEN from './locales/en/coach.json';
import coachFR from './locales/fr/coach.json';
import profileEN from './locales/en/profile.json';
import profileFR from './locales/fr/profile.json';
import accountingEN from './locales/en/accounting.json';
import accountingFR from './locales/fr/accounting.json';
import trialsEN from './locales/en/trials.json';
import trialsFR from './locales/fr/trials.json';
import superadminEN from './locales/en/superadmin.json';
import superadminFR from './locales/fr/superadmin.json';
import adminuiEN from './locales/en/adminui.json';
import adminuiFR from './locales/fr/adminui.json';
import bookinguiEN from './locales/en/bookingui.json';
import bookinguiFR from './locales/fr/bookingui.json';
import appuiEN from './locales/en/appui.json';
import appuiFR from './locales/fr/appui.json';
import superadmin2EN from './locales/en/superadmin2.json';
import superadmin2FR from './locales/fr/superadmin2.json';
import adminui2EN from './locales/en/adminui2.json';
import adminui2FR from './locales/fr/adminui2.json';
import adminui3EN from './locales/en/adminui3.json';
import adminui3FR from './locales/fr/adminui3.json';
import welcomeEN from './locales/en/welcome.json';
import welcomeFR from './locales/fr/welcome.json';




// Configure i18next
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: commonEN,
        dashboard: dashboardEN,
        classes: classesEN,
        clients: clientsEN,
        index: indexEN,
        auth: authEN,
        schedule: scheduleEN,
        settings: settingsEN,
        coaches: coachesEN,
        courses: coursesEN,
        subscriptions: subscriptionsEN,
        athlete: athleteEN,
        inventory: inventoryEN,
        payments: paymentsEN,
        coach: coachEN,
        profile: profileEN,
        trials: trialsEN,
        accounting: accountingEN,
        superadmin: superadminEN,
        adminui: adminuiEN,
        bookingui: bookinguiEN,
        appui: appuiEN,
        superadmin2: superadmin2EN,
        adminui2: adminui2EN,
        adminui3: adminui3EN,
        welcome: welcomeEN
      },
      fr: {
        common: commonFR,
        dashboard: dashboardFR,
        classes: classesFR,
        clients: clientsFR,
        index: indexFR,
        auth: authFR,
        schedule: scheduleFR,
        settings: settingsFR,
        coaches: coachesFR,
        courses: coursesFR,
        subscriptions: subscriptionsFR,
        athlete: athleteFR,
        inventory: inventoryFR,
        payments: paymentsFR,
        coach: coachFR,
        profile: profileFR,
        trials: trialsFR,
        accounting: accountingFR,
        superadmin: superadminFR,
        adminui: adminuiFR,
        bookingui: bookinguiFR,
        appui: appuiFR,
        superadmin2: superadmin2FR,
        adminui2: adminui2FR,
        adminui3: adminui3FR,
        welcome: welcomeFR
      }
    },
    fallbackLng: 'fr',
    debug: false,
    keySeparator: '.',
    nsSeparator: ':',
    interpolation: {
      escapeValue: false // React already escapes values
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    },
    defaultNS: 'common',
  });

export default i18n;
